import React from 'react';
import { faTrafficLight } from '@fortawesome/pro-regular-svg-icons/faTrafficLight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TrafficLightRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faTrafficLight} {...props} />;
}
